import Vue from 'vue'
import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  selectedTeamId: false,
  athletes: {},
  isAthletesLoading: false,
  search: '',
}

// getters
export const getters = {
  getAndSearchAthletesForRound: ({ selectedTeamId, athletes, search }) => ({ roundId, lang = 'en' }) => {
    let roundAthletes = athletes[roundId] || []
    return roundAthletes.filter((athlete) => {
      if (search) {
        if (lang === 'cn') {
          if (athlete.name[lang].indexOf(search) < 0) {
            return false
          }
        } else {
          if (athlete.name[lang].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(search.toLowerCase()) < 0) {
            return false
          }
        }
      }
      if (selectedTeamId) {
        if (athlete.team.id !== selectedTeamId) {
          return false
        }
      }
      return true
    })
  },
}
// mutations
export const mutations = {
  changeSelectedTeam(state, { teamId }) {
    state.selectedTeamId = teamId
    state.search = ''
  },
  changeSearchString(state, { search }) {
    state.search = search
  },
  fetchAthletesStart(state) {
    state.isAthletesLoading = true
  },
  fetchAthletesSuccess(state, { athletes, roundId }) {
    const athletesArray = athletes
      .map((athlete) => processAthlete(athlete))
      .sort(({ score: scoreA, position: positionA }, { score: scoreB, position: positionB }) => {
        const scoreDiff = scoreB - scoreA
        if (scoreDiff === 0 && positionA && positionB) {
          return positionB.id - positionA.id
        }
        return scoreDiff
      }
      )
    Vue.set(state.athletes, roundId, athletesArray)
    state.isAthletesLoading = false
  },
  fetchAthletesFailed(state) {
    state.isAthletesLoading = false
  },
  assignAthleteFinished(state, { roundId }) {
    // eslint-disable-next-line no-undef
    if (dataLayer) {
      if (!localStorage.getItem(`prediction-${roundId}`)) {
        // eslint-disable-next-line no-undef
        dataLayer.push({
          'event': 'prediction',
          'category': 'first',
          'label': 'complete',
          'value': 1,
        })
      }
      localStorage.setItem(`prediction-${roundId}`, true)
    }
  },
}
// actions
export const actions = {
  async handleChangeTeam({ commit, dispatch }, { teamId }) {
    commit('changeSelectedTeam', { teamId })
  },
  async handleAthletesSearch({ commit, dispatch }, { search }) {
    commit('changeSelectedTeam', { teamId: null })
    commit('changeSearchString', { search })
  },

  async fetchRoundAthletes({ commit, state }, { roundId }) {
    if (state.athletes[roundId]) {
      return state.athletes[roundId]
    }
    let response = null
    try {
      commit('fetchAthletesStart')
      response = await axios.post(`round/${roundId}/athletes`)
      commit('fetchAthletesSuccess', {
        athletes: response,
        roundId,
      })
    } catch (e) {
      commit('fetchAthletesFailed')
    }
    return response
  },
  async assignAthleteToRound({ commit, dispatch }, { roundId, athleteId }) {
    try {
      const response = await axios.post(`prediction/${roundId}/assign/${athleteId}`)
      commit('assignAthleteFinished', { roundId })
      return response
    } catch (e) {

    }
  },
  async setNoAthletePickForRound({ commit, dispatch }, { roundId }) {
    try {
      const response = await axios.post(`prediction/${roundId}/noAthlete`)
      commit('assignAthleteFinished', { roundId })
      return response
    } catch (e) {

    }
  },
  async detachAthleteFromRound({ commit, dispatch }, { roundId, athleteId }) {
    try {
      await axios.delete(`prediction/${roundId}/assign/${athleteId}`)
    } catch (e) {

    }
  },
}
